"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Entity_1 = __importStar(require("../../Core/Entity"));
var BaseRoute = '/merchant/applications';
var Routes = {
    //In order to remove app by uuid, need to have a fake app id as a route parameter.
    DELETE_APP_BY_UUID: "".concat(BaseRoute, "/no_id"),
    //In order to get app app id, need to have a fake app uuid as a route parameter.
    GET_BY_ID: "".concat(BaseRoute, "/no_uuid"),
    TEST_SAML_URL: "".concat(BaseRoute, "/test_saml_url")
};
var ApplicationMerchantConfigurationEntity = /** @class */ (function (_super) {
    __extends(ApplicationMerchantConfigurationEntity, _super);
    function ApplicationMerchantConfigurationEntity(session) {
        return _super.call(this, {
            session: session,
            entityName: 'applications',
            routePrefix: 'merchant',
            routes: [Entity_1.BaseRoutes.Get, Entity_1.BaseRoutes.Update, Entity_1.BaseRoutes.Delete, Entity_1.BaseRoutes.Create]
        }) || this;
    }
    ApplicationMerchantConfigurationEntity.prototype.addApplicationById = function (appId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.create(appId)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.application];
                }
            });
        });
    };
    ApplicationMerchantConfigurationEntity.prototype.addApplicationByUuid = function (appUuid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .post(BaseRoute)
                        .withExtractor(function (res) { return res.application; })
                        .setException('could not add application')
                        .withPayload({ uuid: appUuid })
                        .invoke()];
            });
        });
    };
    ApplicationMerchantConfigurationEntity.prototype.removeApplicationById = function (appId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.delete(appId)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.success];
                }
            });
        });
    };
    ApplicationMerchantConfigurationEntity.prototype.removeApplicationByUuid = function (appUuid) {
        return __awaiter(this, void 0, void 0, function () {
            var success;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.routeGenerator
                            .delete(Routes.DELETE_APP_BY_UUID)
                            .withExtractor(function (res) { return res.success; })
                            .setException('could not remove application')
                            .withQueryString({ uuid: appUuid })
                            .invoke()];
                    case 1:
                        success = _a.sent();
                        return [2 /*return*/, success];
                }
            });
        });
    };
    /**
     * Updates the config of the application for the current merchant by either the app's id (number) or uuid (guid string).
     * @param appId The id or uuid of the application to update.
     * @param data The config data.
     */
    ApplicationMerchantConfigurationEntity.prototype.updateConfig = function (appId, data) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.update(appId, { data: data })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.success];
                }
            });
        });
    };
    ApplicationMerchantConfigurationEntity.prototype.getByAppId = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var cachedAppConfig, appConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cachedAppConfig = this.getAppConfigFromMerchantConfigurationByAppId(id);
                        if (cachedAppConfig) {
                            return [2 /*return*/, cachedAppConfig];
                        }
                        return [4 /*yield*/, this.service.routeGenerator
                                .get(Routes.GET_BY_ID)
                                .withExtractor(function (res) { return res.config; })
                                .withQueryString({ id: id })
                                .setException('could not fetch application_merchant_configuration')
                                .invoke()];
                    case 1:
                        appConfig = _a.sent();
                        return [2 /*return*/, appConfig];
                }
            });
        });
    };
    ApplicationMerchantConfigurationEntity.prototype.getByAppUuid = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var cachedAppConfig, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAppConfigFromMerchantConfigurationByUuid(uuid)];
                    case 1:
                        cachedAppConfig = _a.sent();
                        if (cachedAppConfig) {
                            return [2 /*return*/, cachedAppConfig];
                        }
                        return [4 /*yield*/, this.service.get(uuid)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response && response.config];
                }
            });
        });
    };
    ApplicationMerchantConfigurationEntity.prototype.getAppConfigFromMerchantConfigurationByAppId = function (appId) {
        var merchantConfiguration = this.service.session.merchantConfiguration;
        if (merchantConfiguration && merchantConfiguration.application_merchant_configurations) {
            var appConfig = merchantConfiguration.application_merchant_configurations.find(function (appConfig) { return appConfig.application_id === appId; });
            return appConfig;
        }
        return null;
    };
    ApplicationMerchantConfigurationEntity.prototype.getAppConfigFromMerchantConfigurationByUuid = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var app;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getApplicationByUuid(uuid)];
                    case 1:
                        app = _a.sent();
                        return [2 /*return*/, app && this.getAppConfigFromMerchantConfigurationByAppId(app.id)];
                }
            });
        });
    };
    ApplicationMerchantConfigurationEntity.prototype.getApplicationByUuid = function (uuid) {
        return __awaiter(this, void 0, void 0, function () {
            var merchantConfiguration;
            return __generator(this, function (_a) {
                merchantConfiguration = this.service.session.merchantConfiguration;
                if (merchantConfiguration && merchantConfiguration.applications) {
                    return [2 /*return*/, merchantConfiguration.applications.find(function (appConfig) { return appConfig.uuid === uuid; })];
                }
                return [2 /*return*/];
            });
        });
    };
    ApplicationMerchantConfigurationEntity.prototype.testSamlUrl = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.service.routeGenerator
                        .get(Routes.TEST_SAML_URL)
                        .withQueryString({ url: url })
                        .setException('could not get url')
                        .invoke()];
            });
        });
    };
    return ApplicationMerchantConfigurationEntity;
}(Entity_1.default));
exports.default = ApplicationMerchantConfigurationEntity;
//# sourceMappingURL=ApplicationMerchantConfigurationEntity.js.map